<script>
import OrdersList from "@/components/orderslist"
import CustomersApi from "@/services/customers-api";
import {Priviliges} from "../../../privileges";

/**
 * Orders-list component
 */
export default {

  mounted(){
    this.role=sessionStorage.getItem("userr");
    if(sessionStorage.getItem("privileges")!=null){
      this.privileges=sessionStorage.getItem("privileges")
      this.isAdmin=this.privileges.includes(Priviliges[0]["Admin_Role"] )
    }
    if(this.role==1 || this.role==2){
      this.getCustomers()
    }

     
  },

  components: { OrdersList},
  data() {
    return {
      selected:null,
      role:null,
      selectedState:null,
      status:null,
      customersList:[],
      selectedCustomer:null,
      end:null,
      start:null,
      showDrafts:null,
      exportOrdersInProgress: false,
      showUnsynchronisedOrders:null,
      privileges:"",
      isAdmin:false,
    };
  }, 
  methods:{
    getCustomers(){
      CustomersApi.getCustomers(null,null).then(
        response => {
          this.customersList=response;
        }
      )
    },

    exportEXCEL(showDetails){
      this.exportOrdersInProgress = true;
      this.$refs.ordersList.exportOrdersListExcel(showDetails)
      .then(() => {
          this.exportOrdersInProgress = false;
      })
    }

  },
    watch: {
        selected: function() {
            this.selectedCustomer = this.selected ? this.selected.id : null
        },

        selectedState: function() {
            this.status = this.selectedState ? this.selectedState.value : null
        },

        showDrafts: function(){
        },

        start: function(){

        },

        end: function(){

        },

        showUnsynchronisedOrders:function(){
        },

    }       
    }

</script>
<template>
      <div>
        <div class="row mt-4 ">
          <div class="col-12  " >
              <b-button variant="info" @click.prevent="exportEXCEL(true)" :disabled="exportOrdersInProgress" class="float-right mb-4 ml-3">
                <b-spinner small :class="exportOrdersInProgress ? 'mr-1' : 'd-none'"></b-spinner>
                  <i class="fas fa-file-excel text-white font-size-16 m-0 p-0 font-weight-bold align-middle mr-2"></i> 
                  <span class=" font-weight-bold text-white text-uppercase">{{$t('ordersMenu.list.exportDetails')}} </span>
              </b-button>
              <b-button variant="success" @click.prevent="exportEXCEL(false)" :disabled="exportOrdersInProgress" class="float-right mb-4">
                <b-spinner small :class="exportOrdersInProgress ? 'mr-1' : 'd-none'"></b-spinner>
                  <i class="fas fa-file-excel text-white font-size-16 m-0 p-0 font-weight-bold align-middle mr-2"></i> 
                  <span class=" font-weight-bold text-white text-uppercase">{{$t('ordersMenu.list.exportList')}} </span>
              </b-button>
          </div>
        </div>
        <div class="row pt-4 pb-2">
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
            <b-form-checkbox v-if="role==1" v-model="showUnsynchronisedOrders" switch class="mb-1 float-md-left">
              <label :class="showUnsynchronisedOrders ? 'text-primary' : 'text-muted'">{{$t('ordersMenu.showUnsynchronisedOrders')}}</label>
            </b-form-checkbox>
          </div>
          <!-- <div class="col-xl-6 col-lg-6 ">
          </div> -->
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
            <b-form-checkbox v-if="role==1" v-model="showDrafts" switch class="mb-1 float-md-right">
              <label :class="showDrafts ? 'text-primary' : 'text-muted'">{{$t('ordersMenu.showDrafts.text1')}} <strong>{{$t('ordersMenu.showDrafts.text2')}} </strong> {{$t('ordersMenu.showDrafts.text3')}} </label>
            </b-form-checkbox>
          </div>
        </div>
        <!-- <div class="row pt-2">
          <div class="col-xl-9 col-lg-9 ">
          </div>
          <div class="col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12">
            <b-form-checkbox v-if="isAdmin" v-model="showUnsynchronisedOrders" switch class="mb-1 float-md-right">
              <label>{{$t('ordersMenu.showUnsynchronisedOrders')}}</label>
            </b-form-checkbox>
          </div>
        </div> -->
        <div  class="row mt-2">
            <div v-if="role==1"  class="col-md-3 col-xs-12 pr-md-4 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selected">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div>
            <div class="col-md-3 col-xs-12 pr-md-4">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div class="col-md-3 col-xs-12 pr-md-4">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')" label-for="">
                <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div v-if="role==0" class="col-md-3" />
            <div class="col-md-3 col-xs-12">
            <b-form-group :label="$t('lists.status.filter')" label-for="">
                <v-select class="style-vselect" style="font-size:1.2em;" :options="[{name :$t('ordersMenu.statusLabel.new'),value: 1},{name :$t('ordersMenu.statusLabel.confirmed'), value: 2},{name :$t('ordersMenu.statusLabel.alldelivered'), value: 3},{name :$t('ordersMenu.statusLabel.canceled'), value: 4}]" 
                :placeholder="$t('lists.status.label')" label="name" v-model="selectedState" :searchable="false">
                <span slot="no-options">{{$t('lists.emptyLists.label')}} </span>
                </v-select>
            </b-form-group>
            </div>
        </div>
        <OrdersList ref="ordersList"  :isAllOrders="false"  :status.sync=this.status :customerId.sync=this.selectedCustomer :showDrafts.sync=showDrafts :start=start :end=end :showUnsynchronisedOrders.sync=showUnsynchronisedOrders />
      </div>
</template>